module.exports = __webpack_public_path__ + "static/csi_dataviz4-85fbb432114da389a8e96e8c87a7ff83.png";